<template>
    <el-dialog
        title="编辑"
        width="25%"
        :before-close="beforeClose"
        :visible="visible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" class="form">
            <el-form-item prop="transportationCost" label="运输成本:">
                <el-input v-model="form.transportationCost"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="beforeClose">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="btnLoading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { updateTransportCost, checkNeedStartZdcFlowByCost } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
export default {
    name: 'DispatchTransportationCost',
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('运输成本不能为空'));
            } else if (this.componentsData.standardCost === null || this.componentsData.standardCost === undefined) {
                callback(new Error('目标成本为空时不允许修改'));
            } else if (+value === this.componentsData.transportationCost) {
                callback(new Error('请修改后再保存'));
            } else {
                callback();
            }
        };
        return {
            btnLoading: false,
            form: {
                transportationCost: 0
            },
            rules: {
                transportationCost: [
                    { validator: validatePass, trigger: 'blur' }
                ]
            },
            visible: false
        };
    },
    methods: {
        // 关闭
        beforeClose () {
            this.$emit('components-close');
        },
        handleSubmit () {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    const isNeedCheck = await this.checkTransportCost();
                    if (isNeedCheck === false) {
                        this.$confirm('“运输成本”修改后的成本浮动比例,无需成本审核，请确认是否保存修改信息且触发推送BMS计费', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.updateTransportCost();
                        }).catch(() => { });
                    } else if(isNeedCheck === true){
                        this.updateTransportCost();
                    } else {}
                }
            });
        },
        // 校验运输成本修改后的成本浮动，是否需要成本审核
        checkTransportCost () {
            const params = {
                dispatchNo: this.componentsData.dispatchNo,
                afterTransportationCost: +this.form.transportationCost // 修改后运输成本
            }
            return checkNeedStartZdcFlowByCost(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        return res.data;
                    } else {
                        return 'fail';
                    }
                })
                .catch(() => {})
        },
        updateTransportCost () {
            this.btnLoading = true;
            updateTransportCost(this.getParams()).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('保存成功');
                    this.beforeClose();
                }
            }).finally(() => {
                this.btnLoading = false;
            });
        },
        getParams () {
            const params = {
                dispatchNo: this.componentsData.dispatchNo,
                beforeTransportationCost: this.componentsData.transportationCost, // 修改前运输成本
                afterTransportationCost: +this.form.transportationCost // 修改后运输成本
            };
            return params;
        }
    },
    mounted () {
        this.visible = true;
        this.form.transportationCost = this.componentsData.transportationCost;
    }
};
</script>

<style lang="less" >
.form {
    .el-input {
        width: 80%;
    }
}
</style>
